import SeasonName from "%/dynamic-component-editor/standard-pages/season-page/SeasonName.vue";
import SeasonNumber from "%/dynamic-component-editor/standard-pages/season-page/SeasonNumber.vue";
import SeasonDescription from "%/dynamic-component-editor/standard-pages/season-page/SeasonDescription.vue";
import SeasonCoverImage from "%/dynamic-component-editor/standard-pages/season-page/SeasonCoverImage.vue";
import SeasonNumEpisodes from "%/dynamic-component-editor/standard-pages/season-page/SeasonNumEpisodes.vue";
import SeasonEpisodes from "%/dynamic-component-editor/standard-pages/season-page/SeasonEpisodes.vue";
import SeasonContent from "%/dynamic-component-editor/standard-pages/season-page/SeasonContent.vue";
import SeasonButton from "%/dynamic-component-editor/standard-components/season-card-small/SeasonButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacySeason extends LegacyEntity {
  get elements() {
    return {
      SeasonName,
      SeasonNumber,
      SeasonDescription,
      SeasonCoverImage,
      SeasonNumEpisodes,
      SeasonEpisodes,
      SeasonContent,
      // "Go To Season" nav button (show card → season page).
      SeasonButton,
    };
  }
}
